import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Radio } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const TABLE_HEADER = [
  {
    header: 'Doctor Name',
    accessor: 'name'
  }
];

const EQUIPMENT_TABLE_HEADER = [
  {
    header: 'Equipment Name',
    accessor: 'equipment'
  }
];

const ANESTHESIOLOGIST_TABLE_HEADER = [
  {
   header: 'Doctor Name',
    accessor: 'name'
  }
]
export const AddResourcesDetailsForm = ({
  onClose,
  onAdd,
  doctorDropdown,
  editData,
  isEditMode,
  equipmentDropdown
}) => {
  const [input, setInput] = useState('');
  const [selectedRadio, setSelectedRadio] = useState('');
  const [doctorRadio, setDoctorRadio] = useState('');
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        // doctor: Yup.string().required('Please select Service')
      })
    ),
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    const transformedValues = {
      ...formValues,
      type:selectedRadio
    };
    onAdd(transformedValues);
    console.log(transformedValues,"TRANSFORMED VALUE")
    setValue('equipment',"")
    setValue('doctor',"")
  };



  const handleDoctorSelection = (row) => {
    setValue('doctor', row._id);
  };

  const handleEquipmentSelection = (row) => {
    setValue('equipment', row?._id);
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  useEffect(() => {
    if (isEditMode && editData) {
      reset({
        doctor: editData.doctor
      });
    } else {
      reset();
    }
  }, [isEditMode, editData, reset]);

  useEffect(() => {
    if (!isEditMode) {
      reset();
    }
  }, [isEditMode, reset]);

  const handleRadioChange = (event) => {
    const { name } = event.target;
    setSelectedRadio(name);
  };

  const handleDoctorRadioChange = (event) => {
    const { name } = event.target;
    setDoctorRadio(name);
  };

  useEffect(() => {
    if (selectedRadio === 'equipment') {
      setDoctorRadio('');
    }
  }, [selectedRadio]);
  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Doctor Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
          <Stack spacing={1} direction="row" alignItems="center">
            <Radio
              sx={{ flex: 0 }}
              name="doctor"
              checked={doctorRadio === 'doctor'}
              onChange={handleDoctorRadioChange}
            />
            <Typography sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}>
              Doctors
            </Typography>
            <Radio
              sx={{ flex: 0 }}
              name="equipment"
              checked={selectedRadio === 'equipment'}
              onChange={handleRadioChange}
            />
            <Typography sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}>
              Equipment
            </Typography>
          </Stack>

          <Stack spacing={1} direction="row" alignItems="center">
            {doctorRadio === 'doctor' && (
              <>
                <Radio
                  sx={{ flex: 0 }}
                  name="surgeon"
                  checked={selectedRadio === 'surgeon'}
                  onChange={handleRadioChange}
                />
                <Typography sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}>
                  Surgeon
                </Typography>
              </>
            )}
            {doctorRadio === 'doctor' && (
              <>
                <Radio
                  sx={{ flex: 0 }}
                  name="anthesiologist"
                  checked={selectedRadio === 'anthesiologist'}
                  onChange={handleRadioChange}
                />
                <Typography sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}>
                  Anthesiologist
                </Typography>
              </>
            )}
          </Stack>
        </Grid>
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={6}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            {selectedRadio === 'surgeon' ? (
              <Table
                containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
                size="small"
                sx={{ fontSize: '32px' }}
                data={
                  doctorDropdown.filter(
                    (doctor) => doctor.qualification_details?.department.department === 'Surgeon'
                  ) || []
                }
                columns={TABLE_HEADER}
                onRowClick={handleDoctorSelection}
              />
            ) : selectedRadio === 'equipment' ? (
              <Table
                containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
                size="small"
                sx={{ fontSize: '32px' }}
                data={equipmentDropdown || []}
                columns={EQUIPMENT_TABLE_HEADER}
                onRowClick={handleEquipmentSelection}
              />
            ) : selectedRadio === 'anthesiologist' ? (
              <Table
                containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
                size="small"
                sx={{ fontSize: '32px' }}
                data={
                  doctorDropdown.filter(
                    (doctor) => doctor.qualification_details?.department.department === 'Anthesiologist'
                  ) || []
                }
                columns={ANESTHESIOLOGIST_TABLE_HEADER}
                onRowClick={handleDoctorSelection}
              />
            ) : null}
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
              {doctorRadio === 'doctor' ? (
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Secondry Doctor</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    menus={doctorDropdown.map((data) => ({ ...data, name: data.name }))}
                    name="doctor"
                    placeholder="Select Doctor"
                    disabled
                  />
                </Stack>
              ) : selectedRadio === 'equipment' ? (
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Equipment</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    menus={equipmentDropdown.map((data) => ({ ...data, name: data.equipment }))}
                    name="equipment"
                    placeholder="Select Equipment"
                    disabled
                  />
                </Stack>
              ) : null}
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
